import { render, staticRenderFns } from "./TheHistory.vue?vue&type=template&id=65cb7b4c&scoped=true"
import script from "./TheHistory.vue?vue&type=script&lang=js"
export * from "./TheHistory.vue?vue&type=script&lang=js"
import style0 from "./TheHistory.vue?vue&type=style&index=0&id=65cb7b4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cb7b4c",
  null
  
)

export default component.exports